export const consultationFormValidation = () => {
    const consultationForm = document.querySelector('.form--consultation');

    if (!consultationForm) {
        return;
    }

    const msgs = consultationForm.dataset;
    const msgRequired = msgs.msgNameRequired || 'This field is required';
    const msgJobTitleRequired = msgs.msgJobTitleRequired || 'This field is required';
    const msgMinlength = msgs.msgMinlength || 'This field must contain at least 3 characters';
    const msgEmail = msgs.msgEmail || 'Email address is not in valid format';
    const msgPrivacy = msgs.msgPrivacy || 'To submit a form, you need to agree with our Privacy Policy first.';

    $.validator.addMethod("customEmail",
        function(value, element) {
            return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
        },
        msgEmail
    );

    $(".form--consultation").validate({
        rules: {
            'consultation_form[base][name]': {
                required: true,
                minlength: 3,
            },
            'consultation_form[base][email]': {
                required: true,
                customEmail: true,
            },
            'consultation_form[base][jobTitle]': {
                required: true,
                minlength: 3
            },
            'consultation_form[base][privacyPolicy]': {
                required: true,
            },
        },
        messages: {
            'consultation_form[base][name]': {
                required: msgRequired,
                minlength: msgMinlength,
            },
            'consultation_form[base][email]': {
                required: msgRequired,
                email: msgEmail,
                customEmail: msgEmail,
            },
            'consultation_form[base][jobTitle]': {
                required: msgJobTitleRequired,
                minlength: msgMinlength,
            },
            'consultation_form[base][privacyPolicy]': {
                required: msgPrivacy,
            },
        },
        errorElement: 'div',
        errorClass: 'form__error',
        errorPlacement: function(error, element) {
            error.appendTo(element.parent());
        },
        submitHandler: function(form, event) {
            if ($(form).valid()) {
                consultationFormSubmit(event);
            }
            return false;
        },
    }).settings.ignore = [];
};

async function consultationFormSubmit(event) {
    event.preventDefault();
    const formElement = $('.form--consultation');
    let response;

    try {
        const locale = formElement[0].dataset.locale || 'en';
        const documentId = formElement[0].dataset.documentId;
        const emailDocument = formElement[0].dataset.emailDocument;
        const clientEmailDocument = formElement[0].dataset.clientEmailDocument;
        const submitParams = new URLSearchParams();
        if (documentId) submitParams.set('documentId', documentId);
        if (emailDocument) submitParams.set('emailDocument', emailDocument);
        if (clientEmailDocument) submitParams.set('clientEmailDocument', clientEmailDocument);
        const submitParamsString = submitParams.toString();
        const submitRoute = submitParamsString ? `/${locale}/request-consultation/form?${submitParamsString}` : `/${locale}/request-consultation/form`;
        const payload = new FormData(formElement[0]);
        response = await axios.post(submitRoute, payload);

        if ($(formElement).parents('.contact').length > 0) {
            if ($(response.data).filter('.form--consultation').length) {
                $(formElement).parent().find('#recaptcha-scripts').replaceWith($(response.data).filter('#recaptcha-scripts'))
                $(formElement).find('#form-recaptcha').replaceWith($(response.data).find('#form-recaptcha'))
            } else {
                location.href = response.data.data.redirect_uri;
                $(formElement)[0].reset();
            }
        } else {
            $(formElement).html('<div class="form__message"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389955 7.20038 -0.17433 9.00998 0.172936 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89471 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4441 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C17.9971 6.61393 17.048 4.3264 15.3608 2.63919C13.6736 0.951987 11.3861 0.00285814 9 0V0ZM13.3956 7.5456L8.4456 12.4956C8.34113 12.6001 8.2171 12.683 8.08059 12.7395C7.94408 12.7961 7.79776 12.8252 7.65 12.8252C7.50224 12.8252 7.35592 12.7961 7.21941 12.7395C7.0829 12.683 6.95887 12.6001 6.8544 12.4956L4.6044 10.2456C4.3934 10.0346 4.27485 9.7484 4.27485 9.45C4.27485 9.15159 4.3934 8.8654 4.6044 8.6544C4.81541 8.44339 5.10159 8.32485 5.4 8.32485C5.69841 8.32485 5.98459 8.44339 6.1956 8.6544L7.65 10.1088L11.8044 5.9544C11.9089 5.84992 12.0329 5.76704 12.1694 5.7105C12.3059 5.65395 12.4522 5.62485 12.6 5.62485C12.7478 5.62485 12.8941 5.65395 13.0306 5.7105C13.1671 5.76704 13.2911 5.84992 13.3956 5.9544C13.5001 6.05888 13.583 6.18291 13.6395 6.31942C13.696 6.45593 13.7251 6.60224 13.7251 6.75C13.7251 6.89775 13.696 7.04406 13.6395 7.18057C13.583 7.31708 13.5001 7.44112 13.3956 7.5456Z" fill="#0C9B00"/></svg>' + response.data.message + '</div>');
        }        
    } catch (err) {
        const errorResponse = response?.data?.message ?? err.message;
        $(formElement).find('.js-form-error').empty().append(`<div class="form__message form__message--error">${errorResponse}</div>`);
        throw err;
    }
}